@if (loading) {
  <app-loader></app-loader>
} @else {
  <app-show-protocol [protocol]="protocol" (closeEvent)="closeModal($event)"></app-show-protocol>
}
